export default __webpack_public_path__ + "static/media/bhp.5a40cb37.png";